import { useCallback, useEffect, useState } from 'react';
import { MatrixFeature } from '../../types/advise';
import { fetchAdviseFunctionalityMatrix } from './Engagements';
import { selectedFeatures } from '../../utils/adviseMatrix';

/** The features an engagement selected on its Functionality Matrix; null until loaded. */
export const useSelectedMatrixFeatures = (engagementId: string | null) => {
  const [features, setFeatures] = useState<MatrixFeature[] | null>(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setFeatures(null);
    setFailed(false);
    if (!engagementId) return;
    let current = true;
    const loadFeatures = async () => {
      const { data, error } = await fetchAdviseFunctionalityMatrix(engagementId);
      if (!current) return;
      if (error || !data) setFailed(true);
      else setFeatures(selectedFeatures(data.criteria));
    };
    loadFeatures();
    return () => {
      current = false;
    };
  }, [engagementId, attempt]);

  const retry = useCallback(() => setAttempt((count) => count + 1), []);

  return { features, failed, retry };
};
